<template>
 <div>
  <div class="detailsTitle">
    <h4>审批</h4>
    <div @click="back"><i class="fa fa-reply"></i></div>
  </div>
  <el-form :inline="true" :rules="rules" :model="SPfrom" ref="SPfrom" class="demo-form-inline jiaoyan inpBox" label-width="100px" size="mini">
  <div class="tBox" id="pdfDom" style="width:1200px">
      <div class="titlePDF">
        <h4 v-if="data.formType==1||data.formType==5">提货单</h4>
        <h4  v-if="data.formType==2||data.formType==6">货权变更单</h4>
      </div>
      <!-- <p>制单人：{{data.userName}}</p> -->
     <table border="1" cellpadding="0" cellspacing="0"  >
        <tr>
          <td>单号</td>
          <td colspan="3">{{data.formNo}}</td>
          <td>仓库名称</td>
          <td colspan="3">{{data.organizationNameOrAddress}}</td>

        </tr>
        <tr>
          <td v-if="data.formType==2||data.formType==6">收货单位</td>
          <td v-if="data.formType==1||data.formType==5">提货单位</td>
          <td colspan="3">{{data.company?data.company:'-'}}</td>
          <td>提交时间</td>
          <td colspan="3">{{data.submitTime|dateFormat}}</td>
        </tr>
        <tr v-if="data.formType==1||data.formType==2">
          <td>捆包号</td>
          <td>货物类型</td>
          <td>品名</td>
          <td>材质</td>
          <td>规格</td>
          <td>重量(吨)</td>
          <td>货位</td>
          <td>合同号</td>
        </tr>
        <tr v-for="item in goodslist" :key="item.id" v-if="data.formType==1||data.formType==2">
          <td>{{item.cargoBarcode}}</td>
          <td>{{ item.productTypeName}}</td>
          <td>{{item.productName}}</td>
          <td>{{item.model}}</td>
          <td>{{item.specification}}</td>
          <td>{{item.weight}}</td>
          <td>{{item.cargoLocation}}</td>
          <td>{{item.contractNumber}}</td>
        </tr>
        <tr v-if="data.formType==5||data.formType==6">
          <td colspan="2">货物类型</td>
          <td>产地</td>
          <td>材质</td>
          <td>规格</td>
          <td>重量(吨)</td>
          <td colspan="2">件数</td>
        </tr>
        <tr v-for="item in goodslist" :key="item.id" v-if="data.formType==5||data.formType==6">
          <td colspan="2">{{ item.productTypeName}}</td>
          <td>{{item.steelMillName}}</td>
          <td>{{item.model}}</td>
          <td>{{item.specification}}</td>
          <td>{{item.weight}}</td>
          <td colspan="2">{{item.number}}</td>
        </tr>
        <tr>
          <td>合计</td>
          <td  colspan="4">{{data.productNum}}件</td>
          <td  colspan="5">{{data.allWeight}}吨</td>
        </tr>
    </table>
    <div v-if="data.formType==1||data.formType==5">
        <h5>提货人、车明细：</h5>
      <table border="1" cellpadding="0" cellspacing="0" >
        <thead>
          <tr>
            <td>提货车号</td>
            <td>提货单位/人</td>
            <td>纳税人识别号/身份证号</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in carriageList" :key="item.id">
          <td>{{item.vhcNo}}</td>
          <td>{{item.driverName}}</td>
          <td>{{item.driverIdentityNo}}</td>
          </tr>
          <tr v-if="!carriageList"><td colspan="3">暂无数据</td></tr>
        </tbody>
      </table>
    </div>
    <div v-if="data.formType==5" style="margin-top:15px">
      <el-form-item label="有效期至：" prop="">
        {{data.validityTime|dateFormat}}
      </el-form-item>
      <el-form-item label="是否扣车：" prop="">
        {{data.isCarHold==1?'是':'否'}}
      </el-form-item>
      <el-form-item label="外部单号：" prop="">
        {{data.outBillNo}}
      </el-form-item>
    </div>
  </div>
  <div class="addressBox" >
        <h4 class="title">
          <span>处理流程</span>
        </h4>
        <div class="tbox">
          <el-table :data="data.flowAuditLogs"  ref="table" highlight-current-row   >
              <el-table-column prop="checkUserName" width="150px" label="操作者"></el-table-column>
              <el-table-column prop="checkTime" :formatter="dateFormat" width="180px" label="审批时间"></el-table-column>
              <el-table-column property="status" width="120" label="审批状态" >
                <template scope="scope">
                  {{[ "通过", "不通过" ][scope.row.status-1]}}
                </template>
              </el-table-column>
              <el-table-column prop="checkReason" label="审批意见"></el-table-column>
            </el-table>
        </div>
  </div>
  <div class="addressBox" >
        <h4 class="title">
          <span>审批意见</span>
        </h4>
        <el-form-item label="审批：" prop="status">
          <template >
            <el-radio-group v-model="SPfrom.status" >
              <el-radio :label="1" >通过</el-radio>
              <el-radio :label="2">驳回</el-radio>
            </el-radio-group>
          </template>
        </el-form-item>
        <div>
           <el-form-item label="审批意见" class="remark" prop="checkReason"  :rules="SPfrom.status==2?rules.checkReason:[{ required: false, message: '请填写审批意见', trigger: 'blur' }]" >
            <el-input  placeholder=""  maxlength="500" v-model="SPfrom.checkReason"></el-input>
          </el-form-item>
        </div>

  </div>
  <div class="addressBox" >
    <h4 class="title">
      <span>当前处理人</span>
    </h4>
     <el-form-item label="名称：" class="remark" >
           <span>{{data.checkUserName}}</span>
      </el-form-item>

  </div>
  <div class="footerBtn">
      <el-button type="primary" class="bigBtn"   @click="saveFn('')">确 定</el-button>
    </div>
  </el-form>
  <!-- 手机验证 -->
    <el-dialog title="验证" @close="closeDialog" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="dialogVisible" width="400px" center>
      <span>
         <el-form :inline="true" :rules="rules" :model="addFrom" ref="addFrom" class="demo-form-inline jiaoyan" label-width="70px" size="mini">
        <div class="inpBox">
               <el-form-item label="验证码:" prop="code">
                <el-input  placeholder="" v-model.trim="addFrom.code"></el-input>
              </el-form-item>
              <p style="margin:0">已经向{{addFrom.mobile}}发送验证码，请注意查收</p>
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="checkFn('addFrom')">确 定</el-button>
      </span>
    </el-dialog>
 </div>
</template>

<script>
// import html2Canvas from 'html2canvas'
// import JsPDF from 'jspdf'
import { flowAuditDetail, auditFlow, flowPdf, sendSmsCode, checkSmsCode, checkCustomerAvailableNumber } from '@/api/soc-stock'
export default {
  data () {
    let id = this.$route.query.id
    return {
      id: id,
      dialogVisible: false,
      goodslist: [],
      list: [],
      carriageList: [], // 人车明细
      SPfrom: {},
      addFrom: {},
      data: {},
      pdfFile: '',
      rules: {
        status: [{ required: true, message: '请选择是否通过', trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        checkReason: [{ required: true, message: '请填写审批意见', trigger: 'blur' }]
      }
    }
  },
  created () {
    flowAuditDetail({ id: this.id }).then(res => {
      this.goodslist = res.products
      this.data = res
      this.addFrom.mobile = res.cFlowNode.mobile
      this.SPfrom.id = res.id
      this.carriageList = res.carriageInfos
    })
  },
  mounted () {
    let pH = document.documentElement.clientHeight
    this.h = (pH - 46) + 'px'

    // var today = new Date()
    // var chinese = ['〇', '一', '二', '三', '四', '五', '六', '七', '八', '九']
    // var y = today.getFullYear().toString()
    // var m = (today.getMonth() + 1).toString()
    // var d = today.getDate().toString()
    // var result = ''
    // for (var i = 0; i < y.length; i++) {
    //   result += chinese[y.charAt(i)]
    // }
 	  // result += '年'
    // if (m.length == 2) {
    //   if (m.charAt(0) == '1') {
    //     result += ('十' + chinese[m.charAt(1)] + '月')
    //   }
    // } else {
    //   result += (chinese[m.charAt(0)] + '月')
    // }
    // if (d.length == 2) {
    //   result += (chinese[d.charAt(0)] + '十' + chinese[d.charAt(1)] + '日')
    // } else {
    //   result += (chinese[d.charAt(0)] + '日')
    // }
    // document.getElementById('date').innerHTML = result
  },
  methods: {
    saveFn: function (params) {
      this.$refs.SPfrom.validate((valid) => {
        if (valid) {
          if ((this.$route.query.formType == 5 || this.$route.query.formType == 6) && this.SPfrom.status == 1) {
            checkCustomerAvailableNumber(
              {
                status: this.SPfrom.status,
                formType: this.$route.query.formType,
                formId: this.$route.query.formId
              }
            ).then(res => {
              console.log(res)
              if (res == 0) {
                if (this.data.cFlowNode.isValMobile == 2) {
                  this.dialogVisible = true
                  sendSmsCode({ mobile: this.addFrom.mobile }).then(res => {
                  }).catch(error => {
                    this.$message({
                      showClose: true,
                      message: error.message,
                      type: 'error',
                      onClose () {
                      }
                    })
                  })
                } else {
                  this.exaFN()
                }
              } else {
                this.$message.error('该提单下有货物已超过了对应仓库客户库存的可用件数!')
              }
            })
          } else {
            if (this.data.cFlowNode.isValMobile == 2) {
              this.dialogVisible = true
              sendSmsCode({ mobile: this.addFrom.mobile }).then(res => {
              }).catch(error => {
                this.$message({
                  showClose: true,
                  message: error.message,
                  type: 'error',
                  onClose () {
                  }
                })
              })
            } else {
              this.exaFN()
            }
          }
        }
      })
    },
    exaFN () {
      this.$refs.SPfrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          auditFlow(this.SPfrom).then(res => {
            loading.close()
            // if (res) {
            //   this.getPdf()
            // } else {

            // }
            this.$router.push({ name: 'toDoTasks' })
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 验证验证码
    checkFn () {
      this.$refs.addFrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          checkSmsCode(this.addFrom).then(res => {
            loading.close()
            this.$message({
              message: '验证成功',
              type: 'success'
            })
            this.exaFN()
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 货物pdf的base64
    // getPdf () {
    //   var that = this
    //   html2Canvas(document.querySelector('#pdfDom'), {
    //     allowTaint: true
    //   }).then(function (canvas) {
    //     var contentWidth = canvas.width
    //     var contentHeight = canvas.height
    //     // 一页pdf显示html页面生成的canvas高度;
    //     var pageHeight = contentWidth / 592.28 * 841.89
    //     // 未生成pdf的html页面高度
    //     var leftHeight = contentHeight
    //     // 页面偏移
    //     var position = 0
    //     // a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
    //     var imgWidth = 595.28
    //     var imgHeight = 595.28 / contentWidth * contentHeight
    //     var pageData = canvas.toDataURL('image/jpeg', 1.0)
    //     var pdf = new JsPDF('', 'pt', 'a4')
    //     // 有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
    //     // 当内容未超过pdf一页显示的范围，无需分页
    //     if (leftHeight < pageHeight) {
    //       // 在pdf.addImage(pageData, 'JPEG', 左，上，宽度，高度)设置在pdf中显示；
    //       pdf.addImage(pageData, 'JPEG', 0, 25, imgWidth, imgHeight)
    //     } else { // 分页
    //       while (leftHeight > 0) {
    //         pdf.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
    //         leftHeight -= pageHeight
    //         position -= 841.89
    //         // 避免添加空白页
    //         if (leftHeight > 0) {
    //           pdf.addPage()
    //         }
    //       }
    //     }
    //     // 可动态生成
    //     // pdf.save()
    //     var flie = pdf.output('dataurlstring').split('base64,')[1]
    //     const loading = that.$loading({
    //       lock: true,
    //       text: '正在处理...'
    //     })
    //     let formData = new FormData()
    //     formData.append('id', that.data.id)
    //     formData.append('file', flie)
    //     flowPdf(formData).then(res => {
    //       loading.close()
    //       that.$router.push({ name: 'toDoTasks' })
    //     }).catch(error => {
    //       that.$message({
    //         showClose: true,
    //         message: error.message,
    //         type: 'error',
    //         onClose () {
    //           loading.close()
    //         }
    //       })
    //     })
    //   }
    //   )
    // },
    closeDialog () {
      this.$set(this.addFrom, 'code', '')
    },
    back () {
      this.$router.go(-1)// 返回上一层
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      return (
        t.getFullYear() +
        '-' +
        month +
        '-' +
        date +
        ' ' +
        hour +
        ':' +
        minutes +
        ':' +
        seconds
      )
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    }
  }
}
</script>

<style scoped lang='less'>
.tBox{
 padding: 0 30px;
  margin-bottom: 20px;
}
.tbox{
   margin-bottom: 20px;
}
 table{
   width: 100%;
    td{
      padding: 4px 10px;
      text-align: center;
      height:28px;
    }
  }
.titlePDF{
  width: 100%;
  text-align: center;
}
</style>
